import locales from "./locales/locales";
import router from './routes/routes'

export const ReportsModule = {
	name: 'reports',
	routes: router,
	locales: locales,
}